export enum DeviceStatusEnum {

  Null = -1,
  Down = 0,
  Up = 1,
  ParentDown = 2,
  Maintenance = 3,
  Unknown = 4,
  UnMonitored = 232

}
